import {
  provideRouter,
  RouteReuseStrategy,
  withInMemoryScrolling,
} from "@angular/router";
import routes from "src/app/routes";
import { CustomReuseStrategy } from "src/CustomReuseStrategy";

export const routerProviders = [
  provideRouter(
    routes,
    withInMemoryScrolling({
      anchorScrolling: "enabled",
      scrollPositionRestoration: "enabled",
    }),
  ),
  { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
];
